// extracted by mini-css-extract-plugin
export default {"projectItem":"project-item_projectItem__JTsSc","statInfo":"project-item_statInfo__N6tG5"};